import * as tslib_1 from "tslib";
import { throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { OnInit } from '@angular/core';
import { BaseService } from '../base.service';
import { HttpClient } from '@angular/common/http';
var CustomerService = /** @class */ (function (_super) {
    tslib_1.__extends(CustomerService, _super);
    function CustomerService(http) {
        var _this = _super.call(this, 'customer', http) || this;
        _this.http = http;
        return _this;
    }
    CustomerService.prototype.ngOnInit = function () {
    };
    CustomerService.prototype.getCustomerByUserId = function (userId) {
        return this.http.get(this.baseUrl + "customer?f_userId=" + userId + "&f_userId_op==").pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    CustomerService.prototype.updateCustomer = function (id, data) {
        return this.http.put(this.baseUrl + "customer/" + id, data).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    return CustomerService;
}(BaseService));
export { CustomerService };
